/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createContext } from "react";
import { Logger } from "cms/utils/log/logger";

const notImplemented = function () {
    Logger.warn("not implemented");
};

const initialContext = {
    // needsRefresh: false,
    // setNeedsRefresh: notImplemented,
    handleReload: notImplemented,
};

const DocumentSelectorClientContext = createContext(initialContext);
export { DocumentSelectorClientContext };
